import React, { useState } from 'react'
import moment from 'moment'

import Modal from 'react-bootstrap/Modal'

export const DateTime2TextConverter = (props) => {
    const [params, setParams] = useState(dateTime2TextConverterController.extractParams(props.field))

    const show = dateTime2TextConverterController.canConvert(props.field)

    return <Modal show={show} onHide={() => props.onHide()} className="alert">
        <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <input type="radio" name="format" id="format1" value="M/D/YYYY H:mm:ss" checked={params && params.format === "M/D/YYYY H:mm:ss"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format1">{moment().format('M/D/YYYY H:mm:ss')}</label> <br />
            <input type="radio" name="format" id="format2" value="M/D/YYYY" checked={params && params.format === "M/D/YYYY"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format2">{moment().format('M/D/YYYY')}</label> <br />
            <input type="radio" name="format" id="format3" value="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" checked={params && params.format === "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format3">{moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]')}</label><br />
            <input type="radio" name="format" id="format4" value="X" checked={params && params.format === "X"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format4">{moment().format('X')}</label><br />
            <input type="radio" name="format" id="format5" value="x" checked={params && params.format === "x"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format5">{moment().format('x')}</label>
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="submit-btn" data-dismiss="modal" onClick={() => { props.onParamsUpdated(params); props.onHide(); }}>{props.buttonText}</button>
        </Modal.Footer>
    </Modal>
}

class DateTime2TextConverterController {
    convertText = () => { }
    constructor() {
        this.canConvert = (field) => {
            return field && (field.dataset.datatype === "datetime" || field.dataset.datatype === "date")
        }
        this.extractParams = (field) => {
            return field && field.dataset && field.dataset.params ? JSON.parse(decodeURIComponent(escape(atob(field.dataset.params)))) : undefined
        }

        this.convertText = (field) => {
            if (this.canConvert(field)) {
                var params = this.extractParams(field)
                if (params) {
                    return moment(1637377140000).format(params.format)
                }
            }
            return undefined
        }
    }
}

export const dateTime2TextConverterController = new DateTime2TextConverterController()